import { type List as ImmutableList, Record, type RecordOf } from 'immutable';

import type { ReportStoreProps } from '../core/reportStoreTypes';

export const ACCOUNTS_BALANCES_HISTORY_REDUCER_KEY = 'accountsBalancesHistoryStore';
export type ACCOUNTS_BALANCES_HISTORY_REDUCER_KEY = typeof ACCOUNTS_BALANCES_HISTORY_REDUCER_KEY;

export type AccountsBalancesHistoryColumn = {
  field?: string | null;
  headerName?: string | null;
  id: number;
};

export type CellData = {
  columnId: number;
  date?: string | null;
  fieldName?: string | null;
  id?: number;
  isEstimated?: boolean;
  value?: number | null;
};

export type DatedCellData = CellData & {
  date: string;
};

export type AccountBalanceType = {
  cellData?: CellData[];
  colorIndex?: number;
  date?: string | null;
  entityId?: string;
  id?: number;
  name: string;
};

export type AccountsBalancesHistoryPageProps = {
  clientId?: string | null;
  columns?: AccountsBalancesHistoryColumn[];
  columnType?: string;
  endOn?: string | null;
  id?: string | null;
  isDeleted?: boolean | null;
  rowType?: string;
  rows?: AccountBalanceType[];
  startOn?: string | null;
  timestep?: string;
};

export type AccountsBalancesHistoryPage = RecordOf<AccountsBalancesHistoryPageProps>;

export const mkAccountsBalancesHistory = Record<AccountsBalancesHistoryPageProps>({
  columns: undefined,
  columnType: undefined,
  endOn: undefined,
  rowType: undefined,
  rows: undefined,
  startOn: undefined,
  timestep: undefined,
});

export type AccountsBalancesHistoryRowList = ImmutableList<AccountBalanceType>;
export type AccountsBalancesHistoryColumnCollection =
  | AccountsBalancesHistoryColumn[]
  | ImmutableList<AccountsBalancesHistoryColumn>;

export type AccountsBalancesHistoryStoreProps = Omit<
  ReportStoreProps,
  'columns' | 'endOn' | 'error' | 'isLoading' | 'loadPending' | 'rows' | 'startOn'
> & {
  columns?: AccountsBalancesHistoryColumnCollection;
  endOn?: string | null;
  error?: unknown;
  isLoading: boolean;
  loadPending: boolean;
  rows?: AccountsBalancesHistoryRowList;
  startOn?: string | null;
};

export type AccountsBalancesHistoryStore = RecordOf<AccountsBalancesHistoryStoreProps>;

export type BalanceRow = {
  accountId: string;
  accountName: string;
  colorIndex: number;
  oneDayBalance: number | null | undefined;
  oneDayPercent: number | null | undefined;
  specialDayBalance: number | null;
  specialDayPercent: number | null;
  todayBalance: number | null | undefined;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [ACCOUNTS_BALANCES_HISTORY_REDUCER_KEY]: AccountsBalancesHistoryStore;
  }
}
